import React from 'react';
import './config/main.css';
import App from './App';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { TempleConfigProvider } from './context/TempleConfigProvider';
import { UserProvider } from './context/UserProvider';
const root = ReactDOM.createRoot(document.getElementById('root'));
// GA is initialized in App.js using REACT_APP_GA_MEASUREMENT_ID env var - no duplicate init needed

root.render(
  <>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <TempleConfigProvider>
          <UserProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </UserProvider>
        </TempleConfigProvider>
      </PersistGate>
    </Provider>
    <Toaster
      position="top-center"
      gutter={8}
      toastOptions={{
        duration: 5000,
        style: {
          padding: '16px'
        }
      }}
    />
  </>
);
